<template>
  <div>
    <div>
      <div class="px-5 mt-5 pb-5 text-center">
        <v-card :loading="loading" class="p-3 pt-0">
          <data-table
              :data="data"
              :columns="columns"
              :debounce-delay="3000"
              :translate="translate"
              :per-page="[10, 25, 50, 100, 500]"
              :orderBy="tableProps.column"
              :orderDir="tableProps.dir"
              :pagination="paginate"
              @on-table-props-changed="reloadTable"
              :loading="true"
              class="pt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
          >
            <template slot="filters" slot-scope="{ tableFilters, perPage }">
              <filters-table @getInfo="(val)=>{ if (val) tableProps.search = searchBox.search }"
                             v-model="searchBox"></filters-table>
            </template>
          </data-table>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import {dataTableProps} from "@/main";
import {debounce} from "../../../custom";
import FiltersTable from "@/components/Table/filtersTable";

export default {
  name: "relatedAds",
  components: {FiltersTable, TitleRibbon},
  props: {
    Token: {
      default: '',
      require: true
    }
  },
  data() {
    return {
      translate: dataTableProps.translate,
      tableProps: dataTableProps.tableProps,
      paginate: dataTableProps.pagination,
      loading: false,
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.phone}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          searchable: true,
        },
        {
          label: 'شماره',
          name: 'number.phone',
          orderable: true,
          searchable: true,
        },
        {
          label: 'موضوع',
          name: 'title',
          orderable: true,
          searchable: true,
        },
        {
          label: 'وضعیت در دیوار',
          name: 'data.status',
          transform: (val) => {
            const color = val.data.data === null ? 'blue' : val.data.data.statusColor;
            const text = val.data.data === null ? 'نامشخص' : val.data.data.status;
            return `<span class="badge badge-primary mt-2" style="background-color: ${color}">${text}</span>`
          },
          orderable: true,
        },
        {
          label: 'تاریخ ارسال',
          name: 'created_at_p',
          orderable: true,
          searchable: true,
        },
        {
          label: 'تاریخ حذف',
          name: 'expire_at_p',
          transform(val) {
            return val.data.expire_at_p != null ? val.data.expire_at_p : '-'
          },
          orderable: true,
          searchable: true,
        },
      ],
      data: {},
      url: `${url}/smarts/related/${this.Token}`,
      searchBox: {
        search: '',
        length: 10
      },
    }
  },
  methods: {
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this;
      vm.loading = true;
      $.ajax({
        url: url,
        type: 'GET',
        data: query,
        fn: this.getDataForTable,
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: function (data) {
          vm.data = data.data;
          vm.loading = false;
        }
      })
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 700);
    },
  },
  mounted() {
    this.tableProps = {
      search: '',
      length: 10,
      column: 'id',
      dir: 'desc',
      page: 1,
    };
    this.data = {};
    this.getDataForTable(this.url)

    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedNumber = []
      }
    })
  },
  watch: {
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true
    }

  }

}
</script>

<style scoped>

</style>